import humps from "humps";
import * as alert from "lib/alert";
import { getJSON, deleteJSON } from "lib/myAjax";
import Rollbar from "lib/rollbar";
import cdnUrl from "lib/cdnUrl";
import {
  API_BASE_URL,
  API_MAJOR_VERSION,
  API_MINOR_VERSION,
  API_PROVIDER
} from "@user/constant.js";
const qs = require("query-string");
export default {
  fetchUser({ state, rootState, rootGetters }) {
    return new Promise((resolve, reject) => {
      const hhConst = rootGetters.constant;
      const payload = {
        accessToken: rootGetters.token,
        provider: hhConst.provider,
        minorVersion: hhConst.minorVersion
      };
      const formatedPayload = humps.decamelizeKeys(payload);
      const { baseUrl, majorVersion } = rootState.constant;
      getJSON(
        `${baseUrl}/${majorVersion}/users.json?${qs.stringify(
          formatedPayload
        )}`,
        user => {
          let userData = humps.camelizeKeys(user.data);
          userData.avatar = {
            medium: cdnUrl(userData.avatar.medium),
            original: cdnUrl(userData.avatar.original),
            thumb: cdnUrl(userData.avatar.thumb)
          };
          state.user = userData;
          state.loadUser = false;
          resolve();
        },
        err => {
          const error = {
            message: "Something went wrong, failed getting your profile data",
            cause: err
          };
          state.loadUser = false;
          alert.error(error.message);
          Rollbar.error(error.message, error.cause);
          reject(error);
        }
      );
    });
  },
  fetchVouchers({ state, rootState, rootGetters }, type) {
    return new Promise((resolve, reject) => {
      try {
        const hhConst = rootGetters.constant;
        const payload = {
          accessToken: rootGetters.token,
          provider: hhConst.provider,
          minorVersion: hhConst.minorVersion,
          sectionType: type
        };
        const pageNumber = `page[number]=${
          type == "active"
            ? state.activeVouchersPaginationPage
            : state.inactiveVouchersPaginationPage
        }`;
        const pageSize = `page[size]=10;`;
        const formatedPayload = humps.decamelizeKeys(payload);
        const { baseUrl, majorVersion } = rootState.constant;
        getJSON(
          `${baseUrl}/${majorVersion}/users/vouchers.json?${qs.stringify(
            formatedPayload
          )}&${pageNumber}&${pageSize}`,
          response => {
            if (response.data) {
              if (type == "active") {
                state.activeVouchers = state.activeVouchers.concat(
                  humps.camelizeKeys(response.data)
                );
                state.activeVouchersPaginationPage =
                  state.activeVouchersPaginationPage + 1;
              } else if (type == "inactive") {
                state.inactiveVouchers = state.inactiveVouchers.concat(
                  humps.camelizeKeys(response.data)
                );
                state.inactiveVouchersPaginationPage =
                  state.inactiveVouchersPaginationPage + 1;
              }
              resolve();
            } else {
              const error = {
                message: "vouhcer api response is not formated correctly",
                cause: response
              };
              window.rollbar(error.message, error.cause);
              reject(error);
            }
          },
          err => {
            const error = {
              message: "Something went wrong, failed getting your voucher",
              cause: err
            };
            window.rollbar(error.message, error.cause);
            reject(error);
          }
        );
      } catch (err) {
        const error = {
          message: "Something went wrong, failed getting your voucher",
          cause: error
        };
        window.rollbar(err.message, err.error);
        reject(error);
      }
    });
  },
  removeFav({ state }, payload) {
    return new Promise((resolve, reject) => {
      try {
        deleteJSON(
          `/${state.lang}/favs/${payload.restaurant.id}.json`,
          {},
          () => {
            let index = null;
            state.favourites.forEach((item, k) => {
              if (item.id === payload.restaurant.id) {
                index = k;
              }
            });
            const newFavourites = state.favourites;
            newFavourites.splice(index, 1);
            state.favourites = newFavourites;
            state.windowData.totalFavourites =
              state.windowData.totalFavourites - 1;

            resolve();
          },
          err => {
            const error = {
              message:
                "Something went wrong, failed remove restaurant from your list",
              cause: err
            };
            window.rollbar(err.message, err.cause);
            reject(error);
          }
        );
      } catch (err) {
        reject(err);
      }
    });
  },
  loadMoreUpcomingReservations({ state }) {
    return new Promise((resolve, reject) => {
      const url = `/${state.lang}/user/reservations/upcoming.json?page=${state.upcomingPaginationPage}`;
      getJSON(
        url,
        data => {
          state.upcomingReservations = state.upcomingReservations.concat(
            humps.camelizeKeys(data)
          );
          state.upcomingPaginationPage = state.upcomingPaginationPage + 1;
          resolve();
        },
        err => {
          const error = {
            message:
              "Something went wrong, failed getting your upcoming reservation",
            cause: err
          };
          window.rollbar(err.message, err.cause);
          reject(error);
        }
      );
    });
  },
  loadMorePastReservations({ state }) {
    return new Promise((resolve, reject) => {
      const url = `/${state.lang}/user/reservations/past.json?page=${state.pastPaginationPage}`;

      getJSON(
        url,
        data => {
          state.pastReservations = state.pastReservations.concat(
            humps.camelizeKeys(data)
          );
          state.pastPaginationPage = state.pastPaginationPage + 1;
          resolve();
        },
        err => {
          const error = {
            message:
              "Something went wrong, failed getting your past reservation",
            cause: err
          };
          window.rollbar(err.message, err.cause);
          reject(error);
        }
      );
    });
  },
  loadMoreFavourites({ state }) {
    return new Promise((resolve, reject) => {
      const url = `/${state.lang}/favs.json?page=${state.favouritesPaginationPage}&details=true`;

      getJSON(
        url,
        data => {
          state.favourites = state.favourites.concat(humps.camelizeKeys(data));
          state.favouritesPaginationPage = state.favouritesPaginationPage + 1;
          resolve();
        },
        err => {
          const error = {
            message:
              "Something went wrong, failed getting your restaurant favourite list",
            cause: err
          };
          window.rollbar(err.message, err.cause);
          reject(error);
        }
      );
    });
  },
  loadMoreRewards({ state }) {
    return new Promise((resolve, reject) => {
      const url = `/${state.lang}/user/rewards.json?page=${state.rewardsPaginationPage}`;
      getJSON(
        url,
        data => {
          state.rewards = state.rewards.concat(humps.camelizeKeys(data));
          state.rewardsPaginationPage = state.rewardsPaginationPage + 1;
          resolve();
        },
        err => {
          const error = {
            message: "Something went wrong, failed getting your reward list",
            cause: err
          };
          window.rollbar(err.message, err.cause);
          reject(error);
        }
      );
    });
  },
  getDetailReservation({ state, rootState }, reservationId) {
    return new Promise((resolve, reject) => {
      const accessToken = rootState.token;
      const provider = API_PROVIDER;
      const minorVersion = API_MINOR_VERSION;
      const payload = qs.stringify(
        humps.decamelizeKeys({
          accessToken,
          provider,
          minorVersion
        })
      );

      const url = `${API_BASE_URL}/${API_MAJOR_VERSION}/reservations/${reservationId}.json/?${payload}`;
      getJSON(url, r => {
        const response = humps.camelizeKeys(r);
        if (response.data) {
          resolve(response);
        } else {
          const error = {
            cause: response,
            message: "Ops, something went wrong, cannot get detail reservation"
          };
          Rollbar.error(error.message, error.cause);
          reject(error.message);
        }
      });
    });
  }
};
